import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { disableSpeech, calibrateSRE } from "../sreactions";
// import { actions } from "../player-components/current-pathstep-reducer";
import { ModalPrompt, buttonTypes } from "@rosetta/react-common-ui";
// import { selectors } from "../../course/reducer";
import { LionTranslate } from "@rosetta/react-lion";
import { actions as audioQualityModalActions } from "./audio-quality-modals-reducer";
import LowAudioWaveIcon from "./assets/LowAudioWaveIcon";
import LoudAudioWaveIcon from "./assets/LoudAudioWaveIcon";

/**
 * This is the dialog that pops up when the SRE hears silence multiple times in a row.
 *
 * It lets the user choose:
 *  * disable speech,
 *  * re-calibrate speech,
 *  * or continue the learning exercise and ignore the problem.
 *
 */

var IconWrapperDiv = styled.div({ textAlign: "center" });
var TitleWrapperDiv = styled.div({
  textAlign: "center",
  fontSize: 24,
  marginTop: 36,
  marginBottom: 24
});

var SubTitleWrapperDiv = styled.div({
  textAlign: "center",
  marginBottom: 16
});

export var GenericAudioQualityModal = function (_PureComponent) {
  _inherits(GenericAudioQualityModal, _PureComponent);

  function GenericAudioQualityModal() {
    var _temp, _this, _ret;

    _classCallCheck(this, GenericAudioQualityModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.launchCalibrateModal = function () {
      _this.props.calibrateSRE(false, null, null, _this.props.userRestrictedFromDisableSpeech);
      _this.props.tryAgainAction(); // basically hides modal
    }, _this.render = function () {
      var buttons = [{
        labelKey: "sre_audio_quality_modal_btn_continue_without_speech",
        buttonType: buttonTypes.default,
        actionFunc: function actionFunc() {
          _this.props.disableSpeech();
          _this.props.audioQualityModalDisableSpeechAfterAction();
          _this.props.tryAgainAction(); // basically hides modal
        }
      }, {
        labelKey: "sre_audio_quality_modal_btn_try_again",
        actionFunc: function actionFunc() {
          return _this.props.tryAgainAction();
        },
        buttonType: buttonTypes.primary
      }];

      // remove "turn off speech" button, if user cannot disable speech (e.g. an admin has disallowed this for a user)
      if (_this.props.userRestrictedFromDisableSpeech) {
        buttons.shift();
      }

      return React.createElement(
        ModalPrompt,
        {
          dataQa: _this.props.dataQa,
          verticalButtons: false,
          cancelAction: _this.props.tryAgainAction,
          buttons: _this.props.defaultButtonsOverride || buttons
          // bottom of modal link
          , hideTipsSection: _this.props.hideTipsSection,
          tipsLinkAction: _this.launchCalibrateModal,
          tipsLinkLionKey: "sre_audio_quality_modal_btn_adjust_mic"
        },
        (_this.props.useLowAudioWaveIcon || _this.props.useLoudAudioWaveIcon) && React.createElement(
          IconWrapperDiv,
          null,
          _this.props.useLowAudioWaveIcon && React.createElement(LowAudioWaveIcon, null),
          _this.props.useLoudAudioWaveIcon && React.createElement(LoudAudioWaveIcon, null)
        ),
        React.createElement(
          TitleWrapperDiv,
          null,
          React.createElement(LionTranslate, { lionkey: _this.props.headerTextLionKey })
        ),
        React.createElement(
          SubTitleWrapperDiv,
          null,
          React.createElement(LionTranslate, { lionkey: _this.props.subHeaderTextLionKey })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return GenericAudioQualityModal;
}(PureComponent);

GenericAudioQualityModal.defaultProps = {
  userRestrictedFromDisableSpeech: false,
  useLowAudioWaveIcon: false,
  useLoudAudioWaveIcon: false,
  defaultButtonsOverride: null,
  hideTipsSection: false
};

GenericAudioQualityModal.propTypes = {
  dataQa: PropTypes.string,
  userRestrictedFromDisableSpeech: PropTypes.bool,
  useLowAudioWaveIcon: PropTypes.bool,
  useLoudAudioWaveIcon: PropTypes.bool,
  headerTextLionKey: PropTypes.string,
  subHeaderTextLionKey: PropTypes.string,
  tryAgainAction: PropTypes.func,
  defaultButtonsOverride: PropTypes.array, // can also be null, so not required
  hideTipsSection: PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mappedActions = {
  disableSpeech: disableSpeech,
  calibrateSRE: calibrateSRE,
  audioQualityModalDisableSpeechAfterAction: audioQualityModalActions.audioQualityModalDisableSpeechAfterAction
};

var GenericAudioQualityContainer = connect(mapStateToProps, mappedActions)(GenericAudioQualityModal);

export default GenericAudioQualityContainer;